import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import * as Api from "@modules/api";

import { contactUs } from "./thunks";
import { ContactUsState } from "./types";

export const name = "faqs";

const initialState: ContactUsState = {
  contactUs: {
    status: "idle",
  },
};

export const contactUsAsync = createAsyncThunk(name + "/contactUs", contactUs);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactUsAsync.pending, (state) => {
        state.contactUs.status = "loading";
      })
      .addCase(contactUsAsync.fulfilled, (state) => {
        state.contactUs.status = "idle";
      })
      .addCase(contactUsAsync.rejected, (state) => {
        state.contactUs.status = "failed";
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
